<template>
  <div class="container mt-5">
         <h1>
      <b-icon icon="people-fill"></b-icon> Your Approved and Forbidden Courses 

       <div class="float-right" style="margin-top: -62px;"> <b-button v-b-modal.modal-help v-b-tooltip.hover title="Help" class="help"> <b-icon icon="question-square-fill" ></b-icon> Help</b-button> 
       </div>
         <help id="15" />
       </h1>       



     <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-1 variant="info" class="text-left">Approved Courses </b-button>
      </b-card-header>
      <b-collapse id="accordion-1" visible  accordion="my-accordion" role="tabpanel">
        <b-card-body>
       
          <div class="row">  
             <div class="text-center" v-if="isLoading ">
          <b-spinner variant="primary" label="Text Centered"></b-spinner>
        </div>
                <b-card  class="col-md-12 col-sm-12 select mb-5" border-variant="primary" sm="12"  v-if="CousrsesList.length ==0">
   No Data
   </b-card>
               <div v-else class=" col-lg-4 col-md-4 col-sm-12 mb-5"  border-variant="primary"   v-for="(course,index) in CousrsesList.filter(x=> x.IsApproved == true)" :key="index" >

                         
                  <div class=" card p-4" >
                    <b-card-text><strong>Course Code </strong> {{course.CourseCode}}</b-card-text>
                    <b-card-text><strong>Course Name </strong> {{course.CourseNameEN}}</b-card-text>
                    <div class="text-center">
                      <b-button class="subButton">
                        <b-icon icon="check-circle-fill" aria-hidden="true"></b-icon>
                      </b-button>
                      
                      </div>
                      <div class="clearfix"></div>
                      </div>
         
           </div> 
          </div>
        </b-card-body>
      </b-collapse>
    </b-card>
     <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-2 variant="info" class="text-left">Forbidden Courses</b-button>
      </b-card-header>
      <b-collapse id="accordion-2" visible  accordion="my-accordion" role="tabpanel">
        <b-card-body>
       
          <div class="row"> 
             <div class="text-center" v-if="isLoading ">
          <b-spinner variant="primary" label="Text Centered"></b-spinner>
        </div> 
                <b-card  class="col-md-12 col-sm-12 select mb-5" border-variant="primary" sm="12"  v-if="CousrsesList.length ==0">
   No Data
   </b-card>
            <div v-else class=" col-lg-4 col-md-4 col-sm-12 mb-5"  border-variant="primary"   v-for="(course,index) in CousrsesList.filter(x=> x.IsApproved == false)" :key="index" >

                         
                  <div class=" card p-4" >
                     <b-card-text><strong>Course Code </strong> {{course.CourseCode}}</b-card-text>
                    <b-card-text><strong>Course Name </strong>  {{course.CourseNameEN}}</b-card-text>
                    <div class="text-center">
                      <b-button class="subButton">
                        <b-icon icon="dash-circle-fill" aria-hidden="true"></b-icon>
                      </b-button>
                      
                      </div>
                      <div class="clearfix"></div>
                      </div>
         
           </div>  
          </div>
        </b-card-body>
      </b-collapse>
    </b-card>

<div class="col-sm-12 text-right mb-5 mt-5">

<button class="btn btn-primary " @click="()=>$router.push('/Adviser')">Back to advisor</button>
</div>
  </div>
      
</template>

<script>
import StudentAdvisorServices from '../../../services/academic/StudentAdvicessServices'
import Help from '../../Help.vue';
export default {
  components: { Help },
   data(){
     return {
        isLoading : true,
        message : '',
        CousrsesList : []
     }
   },
   mounted(){
      StudentAdvisorServices.Student_Allowed_Forbidden_Courses_get(this.currenUser.StudentID).then((Response) => {
        
        
            this.isLoading = false;
            this.CousrsesList = Response.data;
          // eslint-disable-next-line no-console
           console.log("Select Subject ", Response.data);
        },
        (error) => {
          // eslint-disable-next-line no-console
          // console.log(error.response.status);
          this.isLoading = false ;
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.Message) ||
            error.message ||
            error.toString();

          if (error.response.status == 404) this.message = "";
        }
      );
   },
   computed:{
     currenUser() {
      return this.$store.state.auth.user;
    },
   }
}
</script>

<style>

    .help {
    color: #fff;
    background-color: #ff8600;
    /* padding: 2px 16px; */
}
h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
h1 a {
  color: #ff8600;
}
.btn-info {
    color: #fff;
    background-color: #eef6fb;
    border-color: rgb(178 188 198 / 25%);
    color: #1E5B8B !important;
    padding: 1em 2em !important;
    text-align: left;
    width: 100%;
    font-weight: 800;
}

.btn-info:hover {
    color: #fff !important;
    background-color: #285475;
    border-color: #204866;
}

.btn-info.focus, .btn-info:focus {
 color: #1E5B8B !important;
    background-color: #eef6fb;
    border-color: #204866;
}
.subButton{
  margin-bottom: -50px;
    width: 50%;
    background: #285476;
    text-align: center;
    border: 0px;
}
.show{
  display: block;
}
</style>